<div class="alert alert-info d-sm-flex">
  <div
    class="text-success text-bold text-center text-sm-start align-self-sm-center"
  >
    {{ profile?.fullName }}
  </div>
  <div class="mx-2 d-none d-sm-block align-self-sm-center">|</div>
  <div class="text-center text-sm-start mt-2 mt-sm-0 align-self-sm-center">
    {{ profile?.charityTitle }}
  </div>
  <div class="mx-2 d-none d-sm-block align-self-sm-center">|</div>
  <div class="text-center text-sm-start mt-1 mt-sm-0 align-self-sm-center">
    {{ profile?.positionsTitle }}
  </div>
  <div class="mx-2 d-none d-sm-block align-self-sm-center">|</div>
  <div class="text-center text-sm-start mt-1 mt-sm-0 align-self-sm-center">
    {{ profile?.mobileNumber }}
  </div>
  <div class="mt-2 mt-sm-0 text-center text-sm-start mx-3">
    <button class="btn btn-success" (click)="onEditProfile()">
      {{ editButtonLabel }}
    </button>
  </div>
</div>
